import { Routes } from '@angular/router'
import { HomeComponent } from './home/home.component';
import { UserComponent } from './user/user.component';
import { SignUpComponent } from './user/sign-up/sign-up.component';
import { SignInComponent } from './user/sign-in/sign-in.component';
import { AuthGuard } from './auth/auth.guard';
import { Page1Component } from './page1/page1.component';
import { TransferDetailComponent } from './TransferDetail/transfer-detail.component';
import { EmployeeDepositsComponent } from './employee-deposits/employee-deposits.component'
import { UploadXmlFileComponent } from './upload-xml-file/upload-xml-file.component';
import { FeedbackUploadComponent } from './feedback-upload/feedback-upload.component';
import { FurloughUploadComponent } from './furlough-upload/furlough-upload.component';
import { ListUserComponent } from './user-management/list-user/list-user.component';
import { UpdateUserComponent } from './user-management/update-user/update-user.component';
import { CreateUserComponent } from './user-management/create-user/create-user.component';
import { FileStatusComponent } from './file-status/file-status.component';
import { MenuComponent } from './menu/menu.component';
import { MainPageComponent } from './main-page/main-page.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeedbackErrorEmployeeComponent } from './feedback-error-employee/feedback-error-employee.component';
import { FeedbackErrorFileComponent } from './feedback-error-file/feedback-error-file.component';
import { ChangeCurrentCustomerComponent } from './change-current-customer/change-current-customer.component';
import { PaymentsReportComponent } from './payments-report/payments-report.component';
import { AdminLogsComponent } from './admin-logs/admin-logs.component';
import { CustomerRefreshComponent } from './customer-refresh/customer-refresh.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerListReminderComponent } from './customer-list-reminder/customer-list-reminder.component';
import { CustomerListLossWorkCapacityComponent } from './customer-list-loss-work-capacity/customer-list-loss-work-capacity.component';
import { Form161Component } from './form161/form161.component';
import { FundInstitutionListComponent } from './fund-institution-list/fund-institution-list.component';
import { BankComponent } from './bank/bank.component';
import { BankCreateComponent } from './bank-create/bank-create.component';
import { BankUpdateComponent } from './bank-update/bank-update.component';
import { FundinstitutionUpdateComponent } from './fundinstitution-update/fundinstitution-update.component';
import { FundinstitutionCreateComponent } from './fundinstitution-create/fundinstitution-create.component';
import { FileListComponent } from './MSVFile/file-list/file-list.component';
import { CompleteDataComponent } from '../app/MSVFile/complete-data/complete-data.component';
import { FeedbackStatusFollowUpComponent } from './feedback-status-followup/feedback-status-followup.component';
import { FeedbackStatusFollowUpTotalsComponent } from './feedback-status-followup-totals/feedback-status-followup-totals.component';
import { CustomersNotReportedComponent } from './customers-not-reported/customers-not-reported.component';
import { PreformanceStatusComponent } from './preformance-status/preformance-status.component';
import { PreformanceStatusDetailedComponent } from './preformance-status-detailed/preformance-status-detailed.component';
import { FeedbackStatusSFSyncComponent } from './feedback-status-sf-sync/feedback-status-sf-sync.component';
import { CompareBaseDetailsComponent } from './compare-base-details/compare-base-details.component';

import { Form161FormalyComponent } from './form161-formaly/form161-formaly.component';
import { Form161FormalyListComponent } from './form161-forlmaly-list/form161-forlmaly-list.component';
import { SettingsComponent } from './settings/settings.component';
import { XmlFileEditorComponent } from './xml-file-editer/xml-file-editor.component';

export const appRoutes: Routes = [
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    { path: 'page1', component: Page1Component, canActivate: [AuthGuard] },
    {
        path: 'signup', component: UserComponent,
        children: [{ path: '', component: SignUpComponent }]
    },
    {
        path: 'login', component: UserComponent,
        children: [{ path: '', component: SignInComponent }]
    },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'TransferDetail', component: TransferDetailComponent },
    { path: 'employee-deposits', component: EmployeeDepositsComponent },
    { path: 'upload-xml-file/:id', component: UploadXmlFileComponent },
    { path: 'feedback-upload', component: FeedbackUploadComponent },
    { path: 'furlough-upload', component: FurloughUploadComponent},
    { path: 'list-user', component: ListUserComponent },
    { path: 'update-user/:id', component: UpdateUserComponent },
    { path: 'create-user', component: CreateUserComponent },
    { path: 'file-status', component: FileStatusComponent },
    //{ path: 'feedback-status-followup', component: FeedbackStatusFollowUpComponent },
    //{ path: 'feedback-status-followup-totals', component: FeedbackStatusFollowUpTotalsComponent },
    { path: 'menu', component: MenuComponent },
    { path: 'main-page', component: MainPageComponent },
    { path: 'error-page/:id', component: ErrorPageComponent },
    { path: 'feedback', component: FeedbackComponent },
    { path: 'feedback-error-employee', component: FeedbackErrorEmployeeComponent },
    { path: 'feedback-error-file', component: FeedbackErrorFileComponent },
    { path: 'change-current-customer', component: ChangeCurrentCustomerComponent },
    { path: 'payments-report', component: PaymentsReportComponent },
    { path: 'admin-logs', component: AdminLogsComponent },
    { path: 'customer-refresh', component: CustomerRefreshComponent },
    { path: 'customer-list', component: CustomerListComponent },
    { path: 'customer-list-reminder', component: CustomerListReminderComponent },
    { path: 'customer-list-loss-work-capacity', component: CustomerListLossWorkCapacityComponent },    
    { path: 'form161', component: Form161Component },
    { path: 'fundInstitution-list', component: FundInstitutionListComponent },
    { path: 'bank', component: BankComponent },
    { path: 'bank-create', component: BankCreateComponent },
    { path: 'bank-update/:id/:value', component: BankUpdateComponent },
    { path: 'fundinstitution-update/:id', component: FundinstitutionUpdateComponent },
    { path: 'fundinstitution-create', component: FundinstitutionCreateComponent },
    { path: 'MSV-file-list', component: FileListComponent },
    { path: 'MSV-complete-data/:id', component: CompleteDataComponent },
    { path: 'customers-not-reported', component: CustomersNotReportedComponent },
    //{ path: 'preformance-status', component: PreformanceStatusComponent },
    //{ path: 'preformance-status-detailed', component: PreformanceStatusDetailedComponent },
    { path: 'sf-sync-status', component: FeedbackStatusSFSyncComponent },
    { path: 'compare-base-details', component: CompareBaseDetailsComponent },

    { path : "form161Formaly", component: Form161FormalyComponent},
    { path : "form161Formaly/:formId", component: Form161FormalyComponent},
    { path : "form161Formaly/:formId/:recordId", component: Form161FormalyComponent},
    { path:  "form161List", component : Form161FormalyListComponent},
    { path:  "xml-file-editor", component : XmlFileEditorComponent},

    { path: "settings", component : SettingsComponent},

    { path: "**", component: ErrorPageComponent },
];



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/routes.ts